
/// <reference path="../definition/jquery.d.ts" />r

function logFunction (sender: Igsap, message: string){
    if(g.log)
        console.log(sender.name + " " + message)

}




function animatedScrollTo(targetWithOffset: number, element: JQuery | HTMLElement | any, duration: number, delay: number) {
    TweenMax.to(element, duration, {
        delay: delay,
        scrollTo: { y: targetWithOffset, autoKill: false },
        ease: Power3.easeInOut
    });
}
